import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';

import ReporteFacturacionHitsPorPacList from './components/ReporteFacturacionHitsPorPacList';
import ReporteFacturacionHitsPorPacSearch from './components/ReporteFacturacionHitsPorPacSearch';
import ReporteFacturacionHitsPorPacDownload from './components/ReporteFacturacionHitsPorPacDownload';

const ReporteFacturacionHitsPorPac = (props) => {
  useEffect(() => {
    window.setAppTitle('Facturación hits por pac');
  }, []);

  const handleOnRowClick = (data) => {
    // TODO sin detalle
  };

  return (
    <div>
      <Row>
        <Col
          sm="auto"
          md="9"
          className="mb-2"
        >
          <ReporteFacturacionHitsPorPacSearch />
        </Col>

        {Guardian.allows('reporte.hits.por.pac.descargar') && (
          <Col className="text-right">
            <ReporteFacturacionHitsPorPacDownload />
          </Col>
        )}
      </Row>

      <ReporteFacturacionHitsPorPacList onRowClick={handleOnRowClick} />
    </div>
  );
};

export default ReporteFacturacionHitsPorPac;
